export const categories=[
    {
        id: 1,
        title: "Education",
        icon: require("../assets/edu.png"),
        color: "#00A7E1"
    },
    {
        id: 2,
        title: "Healthcare",
        icon: require('../assets/health.png'),
        color: "#F7A1C4"
    },
    {
        id: 3,
        title: "Shopping",
        icon: require("../assets/shop.png"),
        color: "#F2CD60"
    },
    {
        id: 4,
        title: "Food",
        icon: require("../assets/food.png"),
        color: "#B780DB"
    },
    {
        id: 5,
        title: "Other",
        icon: require("../assets/other.png"),
        color: "#F3FFBD"
    },
]